import React from "react";
import { useSelector } from "react-redux";
import { selectStoreConfig } from "../redux/Slice/siteSlice";
import { storeTypeOf } from "../utils/storeTypes";

// Loading indicators used across the store:
// <Loader label="Loading your orders" /> for a page or a section, <Spinner /> inside a busy button,
// <ProductSkeletons count={8} /> as placeholder cards while a product grid loads.
export default function Loader({ label, page = false }) {
    // The store type's emoji; a neutral bag while the store itself is still loading
    const config = useSelector(selectStoreConfig);
    const icon = config ? storeTypeOf(config.template).icon : "🛍️";
    return (
        <div className={page ? "gnLoader gnLoaderPage" : "gnLoader"} role="status" aria-live="polite">
            <span className="gnLoaderMark" aria-hidden="true">
                <span className="gnLoaderRing" />
                <span className="gnLoaderLeaf">{icon}</span>
            </span>
            {label && <span className="gnLoaderLabel">{label}</span>}
        </div>
    );
}

export function Spinner() {
    return <span className="gnSpinner" aria-hidden="true" />;
}

export function ProductSkeletons({ count = 8 }) {
    return Array.from({ length: count }, (_, index) => (
        <div className="card gnSkeletonCard" key={index} aria-hidden="true">
            <div className="gnSkeleton gnSkeletonPic" />
            <div className="gnSkeleton gnSkeletonLine" />
            <div className="gnSkeleton gnSkeletonLine short" />
            <div className="gnSkeleton gnSkeletonBtn" />
        </div>
    ));
}
